import { render, staticRenderFns } from "./documentaryWork.vue?vue&type=template&id=4c08a858&scoped=true&"
import script from "./documentaryWork.vue?vue&type=script&lang=js&"
export * from "./documentaryWork.vue?vue&type=script&lang=js&"
import style0 from "./documentaryWork.vue?vue&type=style&index=0&id=4c08a858&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c08a858",
  null
  
)

export default component.exports